import IMask from 'imask';

export default class Forms {
    constructor() {
        this._items = Array.from(document.querySelectorAll('.wpcf7'));
    }
    render() {
        if (this._items.length) {
            this._items.forEach((item) => {
                this.setupMasks(item);
            });
        }
    }

    setupMasks(form) {
        const telInputs = Array.from(form.querySelectorAll('input[type="tel"]'));

        if (telInputs.length) {
            telInputs.forEach((item) => {
                new IMask(item, {
                    mask: '{+}00000000000',
                });
            });
        }

        const dateInputs = Array.from(form.querySelectorAll('input.date-field'));

        if (dateInputs.length) {
            dateInputs.forEach((item) => {
                new IMask(item, {
                    mask: Date,
                    pattern: 'd/m/Y',
                    min: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                    max: new Date(),

                    format: function (date) {
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        if (day < 10) day = '0' + day;
                        if (month < 10) month = '0' + month;

                        return [day, month, year].join('/');
                    },
                    // define str -> date convertion
                    parse: function (str) {
                        var yearMonthDay = str.split('/');
                        return new Date(yearMonthDay[2], yearMonthDay[1] - 1, yearMonthDay[0]);
                    },
                });
            });
        }

        const avsFields = Array.from(form.querySelectorAll('input.avs-field'));

        if (avsFields.length) {
            avsFields.forEach((item) => {
                new IMask(item, {
                    mask: '###.####.####.##',
                    definitions: {
                        '#': /[0-9]/,
                    },
                });
            });
        }

        const numAssureFields = Array.from(form.querySelectorAll('input.num-assure-field'));

        if (numAssureFields.length) {
            numAssureFields.forEach((item) => {
                new IMask(item, {
                    mask: '######',
                    definitions: {
                        '#': /[0-9]/,
                    },
                });
            });
        }
    }
}
